export const ESC = 27;
export const ARROW_RIGHT = 39;
export const ARROW_LEFT = 37;
export const SPACE = 32;
export const NUMBER_ONE = 49;
export const ENTER = 'Enter';
